import { Auth } from '../../services';
import Spinner from '../ui/spinner';
import Alert from '../ui/alert';

const markup = `<db:signin>
	<div class='details'>
		<form data-id='signInForm'>
			<div>
				<label>Username</label>
				<input type='text' data-id='username' data-property='value' />
			</div>
			<div>
			<label>Password</label>
				<input type='password' data-id='password' data-property='value' />
			</div>
			<div>
				<input type='submit' value='Sign In' />
			</div>
		</form>
	</div>
</db:signin>`;

global.Spinner = Spinner;

const SignIn = DomClass(markup, function() {
	this.__dom.signInForm.onsubmit = () => {
		const spinner = new Spinner({
			message: "Signing in ..."
		});
		spinner.open();

		const { username, password } = this;

		Auth.signIn({username, password }).then(r => {
			this.username = '';
			this.password = '';
			spinner.close();
			on(this, 'complete').fire(r);
		}).catch(async error => {
			spinner.close();
			switch (error.code) {
				case 'UserNotConfirmedException':
					await Auth.resendSignUp(username);
					const prompt = new Prompt({prompt: `
						<h4>Oh no! You didn't finish your account setup!</h4>
						<p><i>That's OK ...</i> We just sent you another confirmation code <i>just in case</i>.</p>
						<p>When you get it enter it here.</p>
					`})
					on(prompt, 'ok').then(code => {
						Auth.confirmSignUp(this.username, code).then(() => {
							Alert({message: "Great! Try signing in now."});
						}).catch((err) => {
							console.error("Out of band signup code error", err);
							Alert({message: "Well that didn't work. Try that again."});
						});
					});
					break;
				case 'PasswordResetRequiredException':
					new Alert({message: "Whoops! You need to reset your password."});
					on(this, 'require-reset').fire(username);
					break;
				case 'NotAuthorizedException':
					new Alert({message: "Bad credentials. Try again!"});
					break;
				case 'UserNotFoundException':
					new Alert({message: "Bad username. Try again!"});
					break;
				default:
					console.error('Sign in error', JSON.stringify(error));
					new Alert({message: "Error signing in. Please try again."});
			}
			
		});
		return false;
	};
});

export default SignIn;
